import { render, staticRenderFns } from "./actionmodalnarrow.vue?vue&type=template&id=62820954&scoped=true&"
import script from "./actionmodalnarrow.vue?vue&type=script&lang=js&"
export * from "./actionmodalnarrow.vue?vue&type=script&lang=js&"
import style0 from "./actionmodalnarrow.vue?vue&type=style&index=0&id=62820954&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62820954",
  null
  
)

export default component.exports